import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "bulma/css/bulma.min.css";
import "./styles/theme.css";
import "./styles/app.css";

import { App } from "./App";
import { initTheme } from "./app/theme";

initTheme();

const container = document.getElementById("root");
if (!container) throw new Error("Élément #root introuvable dans index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
